import React, { useCallback } from 'react';
import { Tooltip } from 'antd';

import { remoteValues } from '~/common/utils/firebase/remoteConfig';
import { useTheme } from '~/hooks/useTheme';
import { Moon, Sun } from '~/ui/assets/icons';
import { ToggleButton } from './ThemeToggle.styled';

export function ThemeToggle() {
  const { themeName, setTheme } = useTheme();
  const isDark = themeName === 'dark';

  const allowDarkThemeButton =
    localStorage.getItem('allowDarkThemeButton') === 'true' || remoteValues.allowDarkThemeButton;

  const handleToggle = useCallback(() => {
    setTheme(isDark ? 'light' : 'dark');
  }, [isDark, setTheme]);

  if (!allowDarkThemeButton) {
    return null;
  }

  const label = isDark ? 'Modo claro' : 'Modo noturno';

  return (
    <Tooltip placement="bottom" overlayClassName="mt-custom-tooltip small" title={label}>
      <ToggleButton
        type="button"
        data-testid="theme-toggle-button"
        aria-label={isDark ? 'Ativar modo claro' : 'Ativar modo noturno'}
        onClick={handleToggle}
      >
        {isDark ? <Sun /> : <Moon />}
      </ToggleButton>
    </Tooltip>
  );
}
